const CONTROL_ACCESO_QRACCES_LIST = (state, controlaccesoqracces) => {
  if (controlaccesoqracces.code === 1) {
    state.controlaccesoqracces = controlaccesoqracces.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

const CONTROL_ACCESO_SHOW = (state, controlaccesoqracces) => {
  if (controlaccesoqracces.code === 1) {
    state.controlaccesoqracces = controlaccesoqracces.data
    state.controlaccesoqracces.user = controlaccesoqracces.data.formData
    state.status = 'success'
  } else {
    alert(controlaccesoqracces.message)
    state.status = 'error'
  }
}
export default {
  CONTROL_ACCESO_QRACCES_LIST,
  CONTROL_ACCESO_SHOW
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/qracces/mutations.js